export const AccountLoginCodeStatus = {
  ACCOUNT_LOGIN_CODE_STATUS_UNSPECIFIED: 'ACCOUNT_LOGIN_CODE_STATUS_UNSPECIFIED',
  ACCOUNT_LOGIN_CODE_STATUS_ACTIVE: 'ACCOUNT_LOGIN_CODE_STATUS_ACTIVE',
  ACCOUNT_LOGIN_CODE_STATUS_DELETED: 'ACCOUNT_LOGIN_CODE_STATUS_DELETED',
} as const;

export type AccountLoginCodeStatus =
  (typeof AccountLoginCodeStatus)[keyof typeof AccountLoginCodeStatus];

export function normalizeAccountLoginCodeStatus(
  status: AccountLoginCodeStatus | string | number | null | undefined,
): AccountLoginCodeStatus {
  switch (status) {
    case 1:
    case AccountLoginCodeStatus.ACCOUNT_LOGIN_CODE_STATUS_ACTIVE:
    case 'LOGIN_CODE_STATUS_ACTIVE':
      return AccountLoginCodeStatus.ACCOUNT_LOGIN_CODE_STATUS_ACTIVE;
    case 2:
    case AccountLoginCodeStatus.ACCOUNT_LOGIN_CODE_STATUS_DELETED:
    case 'LOGIN_CODE_STATUS_DELETED':
      return AccountLoginCodeStatus.ACCOUNT_LOGIN_CODE_STATUS_DELETED;
    default:
      return AccountLoginCodeStatus.ACCOUNT_LOGIN_CODE_STATUS_UNSPECIFIED;
  }
}

export interface AccountLoginCode {
  id: string;
  app_id: string;
  user_id: string;
  display_name: string;
  code_masked: string;
  status: AccountLoginCodeStatus | string | number;
  expires_at?: string;
  last_used_at?: string;
  created_by: string;
  created_at: string;
  updated_at: string;
  plain_code?: string;
}

export interface AccountLoginCodeSettings {
  app_id: string;
  enabled: boolean;
  updated_by: string;
  updated_at?: string;
}

export interface CreateAccountLoginCodeRequest {
  app_id: string;
  user_id?: string;
  display_name: string;
  expires_at?: string;
  created_by?: string;
}

export interface CreateAccountLoginCodeReply {
  login_code: AccountLoginCode;
}

export interface GetAccountLoginCodeRequest {
  id: string;
}

export interface GetAccountLoginCodeReply {
  login_code: AccountLoginCode;
}

export interface ListAccountLoginCodesRequest {
  app_id: string;
  user_id?: string;
  status?: AccountLoginCodeStatus;
  query?: string;
  page_num: number;
  page_size: number;
}

export interface ListAccountLoginCodesReply {
  login_codes: AccountLoginCode[];
  total: number;
}

export interface DeleteAccountLoginCodeRequest {
  id: string;
  deleted_by?: string;
}

export interface DeleteAccountLoginCodeReply {
  login_code: AccountLoginCode;
}

export interface UpdateAccountLoginCodeExpiryRequest {
  id: string;
  expires_at?: string;
  clear_expires_at?: boolean;
  updated_by?: string;
}

export interface UpdateAccountLoginCodeExpiryReply {
  login_code: AccountLoginCode;
}

export interface GetAccountLoginCodeSettingsRequest {
  app_id: string;
}

export interface GetAccountLoginCodeSettingsReply {
  settings: AccountLoginCodeSettings;
}

export interface UpdateAccountLoginCodeSettingsRequest {
  app_id: string;
  enabled: boolean;
  updated_by?: string;
}

export interface UpdateAccountLoginCodeSettingsReply {
  settings: AccountLoginCodeSettings;
}
